/* eslint-disable no-unused-vars */
export enum MenuItemKeys {
  USERS = 'users',
  USER_PERMISSIONS = 'user-permissions',
  DOMAINS = 'domains',
  DOMAIN_VARS = 'domain-vars',
  DOMAIN_VAR_VALUES = 'domain-var-values',
  CLIENTS = 'clients',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  PERMISSIONS_CATALOGUE = 'permissions-catalogue',
  CLIENT_STATUS = 'client-status',
  DIVIDER = '__divider__'
}
